import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { Locale } from 'vant';
import enUS from 'vant/lib/locale/lang/en-US';
import zhCN from 'vant/lib/locale/lang/zh-CN';
import zhHK from 'vant/lib/locale/lang/zh-HK';
import zhTW from 'vant/lib/locale/lang/zh-TW';
import enLocale from './en';
import zhCNLocale from './zh_cn';
import zhHKLocale from './zh_hk';
import zhTWLocale from './zh_tw';
import idLocale from './id';
import jaLocale from './ja';
import kmLocale from './km';
import koLocale from './ko';
import msLocale from './ms';
import thLocale from './th';
import tlLocale from './tl';
import viLocale from './vi';
import loLocale from './lo';
import ruLocale from './ru';
import kyLocale from './ky';
import uzLocale from './uz';
import mnLocale from './mn';
import esLocale from './es';
import fiLocale from './fi';
import kaLocale from './ka';
Vue.use(VueI18n);

const messages = {
  en: {
    ...enUS,
    ...enLocale,
  },
  'zh-CN': {
    ...zhCN,
    ...zhCNLocale,
  },
  'zh-HK': {
    ...zhHK,
    ...zhHKLocale,
  },
  'zh-TW': {
    ...zhTW,
    ...zhTWLocale,
  },
  id: {
    ...idLocale,
  },
  ja: {
    ...jaLocale,
  },
  km: {
    ...kmLocale,
  },
  ko: {
    ...koLocale,
  },
  ms: {
    ...msLocale,
  },
  th: {
    ...enUS,
    ...thLocale,
  },
  tl: {
    ...tlLocale,
  },
  vi: {
    ...viLocale,
  },
  lo: {
    ...loLocale,
  },
  ru: {
    ...ruLocale,
  },
  ky: {
    ...kyLocale,
  },
  uz: {
    ...uzLocale,
  },
  mn: {
    ...mnLocale,
  },
  es: {
    ...esLocale,
  },
  fi: {
    ...fiLocale,
  },
  ka: {
    ...kaLocale,
  },
}

const i18n = new VueI18n({
  locale: navigator.language, // 设置默认语言
  messages: messages, // 设置资源文件对象
})

// 更新vant组件库本身的语言变化，支持国际化
function vantLocales(lang) {
  // console.log("vantLocales : lang=" + lang)
  if (lang === 'zh-CN') {
    Locale.use(lang, zhCN)
  } else {
    Locale.use(lang, enUS)
  }
}

const languageArray = [
  { lang: 'en', name: 'English' },
  { lang: 'zh-CN', name: '简体中文' },
  { lang: 'zh-HK', name: '繁體中文(香港/澳門)' },
  { lang: 'zh-TW', name: '繁體中文(臺灣)' },
  // 日语
  { lang: 'ja', name: '日本語' },
  // 印度尼西亚语
  { lang: 'id', name: 'Indonesia' },
  // 柬埔寨语
  { lang: 'km', name: 'ភាសាខ្មែរ' },
  // 韩语
  { lang: 'ko', name: '한국어' },
  // 马来语
  { lang: 'ms', name: 'Melayu' },
  // 泰语
  { lang: 'th', name: 'ภาษาไทย' },
  // 他加禄语(菲利宾语)
  { lang: 'tl', name: 'Tagálog' },
  // 越南文
  { lang: 'vi', name: 'Tiếng Việt' },
  // 老挝语
  { lang: 'lo', name: 'ພາສາລາວ' },
  // 俄语
  { lang: 'ru', name: 'Русский язык' },
  // 吉尔吉斯语
  { lang: 'ky', name: 'Кыргыз тили' },
  // 乌兹别克语
  { lang: 'uz', name: 'Oʻzbek tili' },
  // 蒙古语
  { lang: 'mn', name: 'Монгол' },
  // 西班牙语
  { lang: 'es', name: 'Español' },
  // 芬兰语
  { lang: 'fi', name: 'Suomi kieli' },
  //格鲁吉亚语 
  { lang: 'ka', name: 'ქართული' },
  // // 德语
  // { lang: 'de', name: 'Deutsch' },
  // // 荷兰
  // { lang: 'nl', name: 'Nederlands' },
  // // 阿拉伯
  // { lang: 'ar', name: 'اللغة العربية' },
]

function getLanguageArray() {
  return languageArray;
}

function getLang(lang) {
  return getLangDef(lang, 'en');
}

function getLangDef(lang, def) {
  if (lang) {
    lang = lang.replace('_', '-');
    if (lang.indexOf('-') !== -1) {
      for (let index in languageArray) {
        let temp = languageArray[index].lang;
        if (lang === temp || lang.indexOf(temp + '-') !== -1) {
          return temp;
        }
      }
    } else {
      for (let index in languageArray) {
        if (lang === languageArray[index].lang) {
          return lang;
        }
      }
    }
  }
  if (def && def !== 'en') {
    return getLangDef(def, null);
  }
  return 'en';
}

export { i18n, vantLocales, getLanguageArray, getLang }
